<template>
  <div class="dataset-selector">
    <div class="row">
      <div class="col-xs-12">
        <div v-if="lines != null">
          <div class="row" v-show="!locked">
            <div class="col-xs-12">
              <div class="panel panel-info">
                <div class="panel-heading">
                  <div class="form-inline">
                    <btn type="info" @click="apply" class="form-group"
                         :disabled="!complete">
                      Appliquer
                    </btn>
                    <btn type="default" @click="selectLatest" class="form-group">
                      Figés le plus récent
                    </btn>
                    <btn type="default" @click="selectCurrent" class="form-group">
                      Journaliers
                    </btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <sui-selector v-for="(c, i) in lines"
                            :locked="locked"
                            :key="`ds-tab-${i}`"
                            :type="i % 2 === 1 ? 'dark' : ''"
                            :lines="c">
              </sui-selector>
            </div>
          </div>
        </div>
        <div class="panel panel-info" v-else>
          <div class="panel-heading">
            Récupération des données...
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import suiSelector from '@/sui/components/results/selector'
import dataset from '@/sui/tools/dataset'

function buildChoice (label, selected) {
  return {
    label: label,
    type: selected ? 'results' : 'default',
    selected: selected
  }
}

export default {
  name: 'dataset-selector',

  props: {
    availableDatasetsByYear: {
      type: Object,
      default: () => {}
    },

    locked: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    const datasets = {}
    for (let y in this.availableDatasetsByYear) {
      datasets[y] = null
    }

    return {
      datasets: datasets
    }
  },

  methods: {
    apply: function () {
      this.$emit('selected', this.datasets)
    },

    selectLatest: function () {
      for (let y in this.renamedDatasets) {
        const dby = this.renamedDatasets[y]
        if (dby.length === 0) {
          continue
        }

        const latest = dby[dby.length - 1]
        if (latest != null && latest.compare !== '') {
          this.$set(this.datasets, y, latest.value)
        }
      }
    },

    selectCurrent: function () {
      for (let y in this.renamedDatasets) {
        const rd = this.renamedDatasets[y]
        const daily = rd.find(r => r.compare === '')
        if (daily != null) {
          this.$set(this.datasets, y, daily.value)
        }
      }
    }
  },

  watch: {
    availableDatasetsByYear: function (value) {
      for (let y in value) {
        const current = this.datasets[y]
        if (current == null || value[y].indexOf(current) === -1) {
          this.datasets[y] = null
        }
      }
    }
  },

  computed: {
    renamedDatasets: function () {
      const result = {}
      for (let y in this.availableDatasetsByYear) {
        const dby = this.availableDatasetsByYear[y]
        const list = []
        for (let i = 0; i !== dby.length; ++i) {
          const dset = dby[i]

          const datasetType = dataset.getDatasetType(dset)
          const datasetLabel = dataset.getDatasetTypeLabel(datasetType)

          if (datasetType === 1) {
            list.push({ name: `${datasetLabel} ${y}`, value: dset, compare: '' })
          }

          const rg = dset.match(/-([^-]+)-([^-]+)-([^-]+)-([^-]+)/)
          if (rg == null) {
            continue
          }

          const name = `${datasetLabel} (Figé le ${rg[2]}/${rg[3]}/${rg[4]})`
          const compare = `${rg[4]}/${rg[3]}/${rg[2]}`
          list.push({ name: name, value: dset, compare: compare })
        }
        list.sort((a, b) => a.compare.localeCompare(b.compare))
        result[y] = list
      }
      return result
    },

    lines: function () {
      const result = []
      const vm = this
      for (let y in this.renamedDatasets) {
        const dby = this.renamedDatasets[y]
        const current = vm.datasets[y]
        const choices = [ buildChoice('Aucun', current === '') ]
        if (dby == null) {
          continue
        }

        for (let i = 0; i !== dby.length; ++i) {
          const l = dby[i]
          choices.push(buildChoice(l.name, current === l.value))
        }

        result.push(
          [
            {
              title: y,
              choices: choices,
              select: (i) => {
                vm.datasets[y] = i === 0 ? '' : dby[i - 1].value
              }
            }
          ]
        )
      }
      return result
    },

    complete: function () {
      for (let y in this.availableDatasetsByYear) {
        if (this.datasets[y] == null) {
          return false
        }
      }
      return true
    }
  },

  components: {
    'sui-selector': suiSelector
  }
}
</script>
<style scoped lang="less">
</style>
